module.exports = __webpack_public_path__ + "img/Villa_Borna_66.faea161b.jpg";